class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.posterButton = this.querySelector('button[id^="Deferred-Poster-Modal-"]');
    this.template = this.querySelector('template');

    if (this.posterButton) {
      this.posterButton.addEventListener('click', this.loadContent.bind(this));
    }
  }

  loadContent() {
    if (!this.template) return;

    const content = this.template.content.firstElementChild.cloneNode(true);
    this.appendChild(content);
    this.setAttribute('loaded', true);

    if (this.posterButton) {
      this.posterButton.remove();
    }

    // Nếu là video upload từ Shopify → phát ngay
    if (content.tagName === 'VIDEO') {
      try {
        content.play();
      } catch (e) {
        console.warn('DeferredMedia: video cannot autoplay', e);
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
